import { useEffect, useRef } from 'react'
import { Form, InputGroup } from 'react-bootstrap'

export default function File(props) {

    const { label_name, disabled, name, onChange, onFileSelect, onBlur, error, accept, mandatory, reference, tabIndex, spinner, value } = props
    const inputRef = useRef(null)
    const onFileSelectRef = useRef(onFileSelect)
    onFileSelectRef.current = onFileSelect

    useEffect(() => {
        const input = inputRef.current
        if (!input) return
        const onPick = (event) => {
            const file = event.target?.files?.[0] || null
            onFileSelectRef.current?.(file)
        }
        input.addEventListener('change', onPick)
        return () => input.removeEventListener('change', onPick)
    }, [])

    const assignRef = (node) => {
        inputRef.current = node
        if (typeof reference === 'function') reference(node)
        else if (reference && typeof reference === 'object') reference.current = node
    }

    useEffect(() => {
        if (value === undefined) return
        const input = inputRef.current
        if (!input) return
        if (value instanceof File) {
            if (input.files?.[0] === value) return
            const dataTransfer = new DataTransfer()
            dataTransfer.items.add(value)
            input.files = dataTransfer.files
            return
        }
        input.value = ''
    }, [value])

    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                {label_name === '' ? '' : <Form.Label className='form_label'>{label_name}{mandatory ? <span style={{ color: 'red' }}>*</span> : ''}</Form.Label>}
                <InputGroup>
                    <Form.Control
                        ref={assignRef}
                        type="file"
                        size="sm"
                        disabled={disabled}
                        className='form_input'
                        name={name}
                        onChange={(event) => {
                            const file = event.target?.files?.[0] || null
                            onFileSelect?.(file)
                            onChange?.(event)
                        }}
                        onBlur={onBlur}
                        accept={accept}
                        tabIndex={tabIndex}
                    />
                    {spinner &&
                        <div className="ms-1 text-center">
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }
                </InputGroup>
                {error}
            </Form.Group>
        </>
    )
}
